import { render, staticRenderFns } from "./KpiWidgetChart.vue?vue&type=template&id=6b2df5ec"
import script from "./KpiWidgetChart.vue?vue&type=script&lang=js"
export * from "./KpiWidgetChart.vue?vue&type=script&lang=js"
import style0 from "./KpiWidgetChart.vue?vue&type=style&index=0&id=6b2df5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports